import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { fiInvoiceMethodTypeName } from '../customer-billing-invoice/invoice-method-type';

@Pipe({
    name: 'fiInvoiceMethodTypeName',
    standalone: false,
})
export class InvoiceMethodTypeNamePipe implements PipeTransform {
    constructor(private appText: AppTextService) {}

    transform(value: any, args?: any): any {
        return fiInvoiceMethodTypeName(value, this.appText);
    }
}
